function formatINR(value) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2
  }).format(Number(value));
}

/* -----------------------------
   GLOBAL STATE
----------------------------- */

let activeSection = null;
let activeLimit = null;

let comboState = {
  5: [],
  10: [],
  20: []
};
// each item will be:
// { id, image }


/* -----------------------------
   INIT
----------------------------- */

document.querySelectorAll('.combo-section').forEach(section => {
  const limit = parseInt(section.dataset.combo);

  section.querySelectorAll('.combo-box').forEach(box => {
    box.addEventListener('click', () => {
      activeSection = section;
      activeLimit = limit;
      openDrawer();
    });
  });

  section.querySelector('.buy-combo-btn').addEventListener('click', () => {
    startCheckout(limit);
  });
});


/* -----------------------------
   DRAWER
----------------------------- */

function openDrawer() {
  document.getElementById('combo-drawer').style.display = 'block';
  loadProducts();
}

document.getElementById('close-drawer').onclick = () => {
  document.getElementById('combo-drawer').style.display = 'none';
};

/* -----------------------------
   LOAD PRODUCTS (MULTI SELECT)
----------------------------- */

function loadProducts() {
  fetch(`/collections/${document.querySelector('.make-combo-wrapper').dataset.collection}/products.json`)
    .then(res => res.json())
    .then(data => {
      const container = document.getElementById('drawer-products');
      container.innerHTML = '';

      const selected = comboState[activeLimit];

      document.getElementById('drawer-title').innerText =
        `Selected ${selected.length} / ${activeLimit}`;

      data.products.forEach(product => {
        const variant = product.variants[0];

        // Only block if limit reached
        const isDisabled = selected.length >= activeLimit;

        const card = document.createElement('div');
        card.className = `combo-product-card ${isDisabled ? 'disabled' : ''}`;

        card.innerHTML = `
          <img src="${product.images[0]?.src}">
          <div class="combo-product-info">
            <div class="title">${product.title}</div>
            <div class="price">${formatINR(variant.price)}</div>
          </div>
        `;

        if (!isDisabled) {
          card.onclick = () => toggleProduct({
            id: variant.id,
            image: product.images[0]?.src
          });
        }

        container.appendChild(card);
      });
    });
}



/* -----------------------------
   TOGGLE PRODUCT
----------------------------- */

function toggleProduct(product) {
  let list = comboState[activeLimit];

  if (list.length >= activeLimit) return;

  list.push(product);

  updateBoxesUI();
  loadProducts();

  if (list.length === activeLimit) {
    document.getElementById('combo-drawer').style.display = 'none';
  }
}



/* -----------------------------
   UPDATE BOXES + BUTTON
----------------------------- */

function updateBoxesUI() {
  const section = document.querySelector(`.combo-section[data-combo="${activeLimit}"]`);
  const boxes = section.querySelectorAll('.combo-box');
  const selected = comboState[activeLimit];

  boxes.forEach((box, index) => {
    const item = selected[index];

    if (!item) {
      box.innerHTML = `<span class="plus">+</span>`;
      return;
    }

    box.innerHTML = `
  <div class="combo-img-wrap">
    <img src="${item.image}">
    <span class="combo-remove">×</span>
  </div>
`;

box.querySelector('.combo-remove').onclick = (e) => {
  e.stopPropagation();
  comboState[activeLimit].splice(index, 1);
  updateBoxesUI();
};


  });

  section.querySelector('.count').innerText =
    `${selected.length}/${activeLimit}`;

  section.querySelector('.buy-combo-btn')
    .classList.toggle('active', selected.length === activeLimit);
}



/* -----------------------------
   CHECKOUT (ALL PRODUCTS TOGETHER)
----------------------------- */

function startCheckout(limit) {
  if (comboState[limit].length !== limit) return;

  showLoader();

  const items = comboState[limit].map(p => ({
    id: p.id,
    quantity: 1
  }));

  fetch('/cart/clear.js', { method: 'POST' })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
    })
    .then(() => {
      let code = '';
      if (limit === 5) code = 'CMB5X92KQ';
      if (limit === 10) code = 'CMB10P8LM';
      if (limit === 20) code = 'CMB20Z4RT';

      window.location.href = `/checkout?discount=${code}`;
    })
    .catch(() => {
      hideLoader();
      alert('Something went wrong. Please try again.');
    });
}



/* -----------------------------
   Add to cart loader spinner
----------------------------- */

function showLoader() {
  const loader = document.getElementById('combo-loader');
  loader.style.display = 'flex';
}

function hideLoader() {
  const loader = document.getElementById('combo-loader');
  loader.style.display = 'none';
}
